import React, { ReactNode, useEffect, useRef, useState } from "react"
import { AdminIcons } from "../Shared/AdminIcon"
import { ScreenHeader } from "../UI/Elements"
import { useTranslationsManager } from "./useTranslationsManager";
import Select from 'react-select';
import { Overlay } from "../UI/Overlay";

export const TranslationsManager = () => {

    const ops = useTranslationsManager();

    useEffect(() => {
        ops.load();
    }, [, ops.plantTypeId]);



    const show_no = ops.selectedLanguages.indexOf("no") >= 0;
    const show_en = ops.selectedLanguages.indexOf("en") >= 0;
    const show_en_us = ops.selectedLanguages.indexOf("en-us") >= 0;

    const show_field_name = ops.selectedFields.indexOf("name") >= 0;
    const show_field_specifictype = ops.selectedFields.indexOf("specifictype") >= 0;
    const show_field_public_description = ops.selectedFields.indexOf("public_description") >= 0;



    return (
        <div className="translations-screen">
            <Overlay visible={ops.loading} />
            <ScreenHeader text="Översättningar" icon={AdminIcons.language} />

            {/****************************************** TOOLBOX *******************************************/}
            <div className="toolbox">
                <div>
                    <label>filtrera namn</label><br />
                    <input type="text" onChange={e => ops.filterName(e.target.value)} />
                </div>
                <div style={{ minWidth: "350px" }}>
                    <label>Typ</label>

                    <Select
                        value={(ops.plantTypes ?? []).find(obj => obj.value === ops.plantTypeId)}
                        options={ops.plantTypes}
                        onChange={(e) => {
                            ops.setPlantTypeId(e.value);
                        }}
                    />
                </div>
                <div style={{ minWidth: "350px" }}>
                    <label>Språk</label>
                    <div className="langs">
                        {ops.ALL_LANGUAGES.map((l: string) => (
                            <div key={l} className="lang">
                                <input id={"lang-" + l} type="checkbox" checked={
                                    ops.selectedLanguages.indexOf(l) >= 0
                                }
                                    onChange={e => ops.setLanguages(l)}
                                />
                                <label htmlFor={"lang-" + l}>{l}</label>
                            </div>
                        ))}

                    </div>
                </div>
                <div style={{ minWidth: "350px" }}>
                    <label>Fält</label>
                    <div className="langs">
                        {ops.ALL_FIELDS.map((f: string) => (
                            <div key={f} className="lang">
                                <input id={"field-" + f} type="checkbox" checked={
                                    ops.selectedFields.indexOf(f) >= 0
                                }
                                    onChange={e => ops.setSelectedFields(f)}
                                />
                                <label htmlFor={"lang-" + f}>{f}</label>
                            </div>
                        ))}

                    </div>
                </div>

                {Object.keys(ops.changes ?? {}).length > 0 && (
                    <div>
                        <div>{Object.keys(ops.changes ?? {}).length} förändringar:</div>
                        <button onClick={ops.saveChanges}>
                            Spara förändringar
                        </button>
                        {/* {JSON.stringify(ops.changes)} */}
                    </div>
                )}
            </div>
            <hr />

            {/****************************************** TABLE *******************************************/}

            <div>
                <table className="tbl tbl-small translations">
                    <thead id="translations-tbl-header">
                        <tr>
                            <th onClick={() => ops.setSort("name")}>Namn (SE)</th>
                            <th onClick={() => ops.setSort("specifictype")}>Sort (SE)</th>
                            {show_field_public_description && (<th onClick={() => ops.setSort("public_description")}>Beskrivning (SE)</th>)}


                            <th>Ändrad</th>

                            {show_no && (<>

                                <Th visible={show_field_name} >
                                    <span onClick={() => ops.setSort("name_no")}>Namn NO</span>
                                    <button onClick={() => { ops.missing("name_no") }}>
                                        Saknade översättningar
                                    </button>
                                    <button onClick={() => { ops.resetFilter() }}>
                                        Ta bort filter
                                    </button>
                                </Th>

                                <Th visible={show_field_specifictype} >
                                    <span onClick={() => ops.setSort("specifictype_no")}>Sort NO</span>
                                    <button onClick={() => { ops.missing("specifictype_no") }}>
                                        Saknade översättningar
                                    </button>
                                    <button onClick={() => { ops.resetFilter() }}>
                                        Ta bort filter
                                    </button>
                                </Th>

                                <Th visible={show_field_public_description} >
                                    <span onClick={() => ops.setSort("public_description_no")}>Beskrivning NO </span>
                                    <button onClick={() => { ops.missing("public_description_no") }}>
                                        Saknade översättningar
                                    </button>
                                    <button onClick={() => { ops.resetFilter() }}>
                                        Ta bort filter
                                    </button>
                                </Th>

                            </>)}


                            {show_en && (<th>EN-GB</th>)}
                            {show_en && (<th>EN-GB</th>)}
                            {show_en_us && (<th>EN-US</th>)}



                        </tr>
                    </thead>
                    <tbody id="translations-tbl-body">
                        {ops.dataFiltered?.filter(m => !!m?.name).map(p => (
                            <tr key={p?.id} data-id={p?.id}>
                                <Td visible={true} >{p?.name}</Td>
                                <Td visible={true} >{p?.specifictype}</Td>
                                <Td className="show-linebreaks" visible={show_field_public_description} >{p?.public_description}</Td>

                                <td>
                                    {!!ops.changes?.[p?.id] && (
                                        <span className="changed">
                                            *
                                        </span>
                                    )}
                                </td>
                                {/* NO */}
                                {show_no && (
                                    <>
                                        <Td visible={show_field_name} >
                                            <TranslationInput value={p?.name_no} onChange={e => {
                                                ops.addUpdate(p, "name_no", e);
                                            }} hasChanged={!!ops.changes?.[p?.id]?.name_no} onUndo={() => ops.addUpdate(p, "name_no", p?.name_no)} />
                                        </Td>

                                        <Td visible={show_field_specifictype} >
                                            <TranslationInput value={p?.specifictype_no} onChange={e => {
                                                ops.addUpdate(p, "specifictype_no", e);
                                            }} hasChanged={!!ops.changes?.[p?.id]?.specifictype_no} onUndo={() => ops.addUpdate(p, "specifictype_no", p?.specifictype_no)} />
                                        </Td>
                                        <Td visible={show_field_public_description} >
                                            <TranslationInput textarea={true} value={p?.public_description_no} onChange={e => {
                                                ops.addUpdate(p, "public_description_no", e);
                                            }} hasChanged={!!ops.changes?.[p?.id]?.public_description_no}
                                                onUndo={() => ops.addUpdate(p, "public_description_no", p?.public_description_no)}
                                                onTranslate={async () => {
                                                    return await ops.translateText(p?.public_description, p?.name, "no");
                                                }}
                                            />
                                        </Td>
                                    </>

                                )}

                                {/* EN */}
                                {show_en && (
                                    <>

                                        <Td visible={show_field_name}>
                                            <TranslationInput value={p?.name_en} onChange={e => {
                                                ops.addUpdate(p, "name_en", e);
                                            }} hasChanged={!!ops.changes?.[p?.id]?.name_en} onUndo={() => ops.addUpdate(p, "name_en", p?.name_en)} />
                                        </Td>
                                        <Td visible={show_field_specifictype}>
                                            <TranslationInput value={p?.specifictype_en} onChange={e => {
                                                ops.addUpdate(p, "specifictype_en", e);
                                            }} hasChanged={!!ops.changes?.[p?.id]?.specifictype_en} onUndo={() => ops.addUpdate(p, "specifictype_en", p?.specifictype_en)} />
                                        </Td>
                                        <Td visible={show_field_public_description} >
                                            <TranslationInput textarea={true} value={p?.public_description_en} onChange={e => {
                                                ops.addUpdate(p, "public_description_en", e);
                                            }} hasChanged={!!ops.changes?.[p?.id]?.public_description_en}
                                                onUndo={() => ops.addUpdate(p, "public_description_en", p?.public_description_en)}
                                                onTranslate={async () => {
                                                    return await ops.translateText(p?.public_description, p?.name, "en");
                                                }}
                                            />
                                        </Td>
                                    </>

                                )}


                                {/* EN-US */}
                                {show_en_us && (
                                    <>

                                        <Td visible={show_field_name} >
                                            <TranslationInput
                                                value={p?.["name_en-us"]}
                                                onChange={e => ops.addUpdate(p, "name_en-us", e)}
                                                hasChanged={!!ops.changes?.[p?.id]?.["name_en-us"]}
                                                onUndo={() => ops.addUpdate(p, "name_en-us", p?.["name_en-us"])} />
                                        </Td>
                                        <Td visible={show_field_specifictype} >
                                            <TranslationInput
                                                value={p?.["specifictype_en-us"]}
                                                onChange={e => ops.addUpdate(p, "specifictype_en-us", e)}
                                                hasChanged={!!ops.changes?.[p?.id]?.["specifictype_en-us"]}
                                                onUndo={() => ops.addUpdate(p, "specifictype_en-us", p?.["specifictype_en-us"])} />
                                        </Td>


                                        <Td visible={show_field_public_description} >
                                            <TranslationInput textarea={true} value={p?.["public_description_en-us"]} onChange={e => {
                                                ops.addUpdate(p, "public_description_en-us", e);
                                            }} hasChanged={!!ops.changes?.[p?.id]?.["public_description_en-us"]}
                                                onUndo={() => ops.addUpdate(p, "public_description_en-us", p?.["public_description_en-us"])}
                                                onTranslate={async () => {
                                                    return await ops.translateText(p?.public_description, p?.name, "en-us");
                                                }}
                                            />
                                        </Td>

                                    </>
                                )}

                            </tr>
                        ))}
                    </tbody>
                </table>

            </div>
        </div>
    )
}


const Td = ({ visible, children, className }: { visible: boolean, children: ReactNode, className?: string }) => {
    if (!visible) { return (null) }
    return (
        <td className={className}>
            {children}
        </td>
    )
}
const Th = ({ visible, children }: { visible: boolean, children: ReactNode }) => {
    if (!visible) { return (null) }
    return (
        <th>
            {children}
        </th>
    )
}


const TranslationInput = ({ value, hasChanged, onChange, onUndo, textarea, onTranslate }: { value: string, hasChanged: boolean, onChange(e: string): void, onUndo(): void, textarea?: boolean, onTranslate?(): Promise<string> }) => {

    const [_value, _setValue] = useState<string>(value);


    return (
        <div className="inp">

            {!!textarea && (
                <>
                    <textarea
                        className={"translation-input" + (hasChanged ? " changed-input" : "")}
                        value={_value}
                        onChange={e => {
                            _setValue(e.target.value)
                            onChange(e.target.value);
                        }} />

                    {!_value && (
                        <button className="btn" onClick={async () => {
                            const str = await onTranslate();
                            _setValue(str);
                            onChange(str);
                        }}>Översätt</button>
                    )}
                </>
            )}
            {!textarea && (
                <input type="text"
                    className={"translation-input" + (hasChanged ? " changed-input" : "")}
                    value={_value}
                    onChange={e => {
                        _setValue(e.target.value)
                        onChange(e.target.value);
                    }} />
            )}



            {hasChanged && (
                <button className="btn" onClick={() => {
                    _setValue(value ?? "")
                    onUndo();
                }}>Ångra</button>
            )}
        </div>)


}